// Redirect to account page if user is redirected from b2b domain
var referringURL = document.referrer;
var specificDomain = "https://b2b.altruan.de/";

if (referringURL.indexOf(specificDomain) !== -1) {
  // Get current domain's TLD
  var currentHost = window.location.hostname;
  var newUrl = "https://" + currentHost + "/account";
  
  window.location.href = newUrl;
}

//--- hide the sidebar image and slider in vendor or type in url

window.addEventListener("DOMContentLoaded", function () {
  let url = window.location.href;
  let elementToHide = document.querySelector(".filter-item.banner");
  let collectionSidebar = document.getElementById("CollectionSidebar");

  if (url.includes("types?q") || url.includes("vendors?q")) {
    if (elementToHide) {
      elementToHide.style.display = "none";
    }
    if (collectionSidebar) {
      let filterItems = collectionSidebar.querySelectorAll(".filter-item");
      if (filterItems.length > 0) {
        let lastFilterItem = filterItems[filterItems.length - 1];
        lastFilterItem.style.display = "none";
      }
    }
  }
});
//--- hide the sidebar image and slider in vendor or type in url

window.addEventListener("DOMContentLoaded", function () {
  hideElementsInParent("bls__product-details-infor", "product-form");
  hideElementsInParent("bls__product-details-infor", "slidecontainer");
  hideElementsInParent("bls__grid__item", "bls__product-addtocart");
  hideElementsInParent("bls__grid__item", "bls__product-quickview");

  const priceLoginElements = document.querySelectorAll(".price-login");
  //  List of blocked domains (Hungary, USA, Canada, Indonesia)
  const blockedDomains = [ ".us",".com", ".ca"]; 

  // Check if the current hostname contains any of the blocked domains
  const isBlocked = blockedDomains.some(domain => window.location.hostname.includes(domain));

  //  Only allow redirection if it's NOT a blocked domain
  if (!isBlocked) {
    priceLoginElements.forEach((element) => {
      element.addEventListener("click", () => {
        const accountLink = document.querySelector('a[href="/account"]');
        if (accountLink) {
          accountLink.click();
        }
      });
    });
  }
});

 /* if (!window.location.hostname.includes(".com")) {
    priceLoginElements.forEach((element) => {
      element.addEventListener("click", () => {
        const accountLink = document.querySelector('a[href="/account"]');
        if (accountLink) {
          accountLink.click();
        }
      });
    });
  }
  
});*/
function hideElementsInParent(parentClass, elementToHide) {
  const priceHiddenElements = document.querySelectorAll("p.price-hidden");

  priceHiddenElements.forEach((pTag) => {
    const parentDiv = pTag.closest(`div.${parentClass}`);

    if (parentDiv) {
      const elementsToHide = parentDiv.querySelectorAll(`.${elementToHide}`);

      elementsToHide.forEach((element) => {
        element.style.display = "none";
      });
    }
  });
}

// This script updates the quantity input based on the URL parameter.

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

document.addEventListener("DOMContentLoaded", () => {
  const quantityParam = getQueryParam("quantity");
  if (quantityParam) {
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = quantityParam;
      quantityInput.dispatchEvent(new Event("change"));
    }
  }
});

// This script updates the quantity input based on the URL parameter.





